import {html} from 'lit-html';
import {classMap} from 'lit-html/directives/class-map';
import {styleMap} from 'lit-html/directives/style-map';
import TemplateRegistry from '../template/template-registry';
import {sizeClassMap, buttonStyleMap, buttonColorStyleMap} from '../template/template-util.js';

TemplateRegistry.templates['download'] = (option, config, onChange) => {
    return html`
            <div class="cl-po--swatch-container">
                 <label class="cl-po--swatch-item ${classMap({ grow: option.params.grow })}" >
                        <div class="cl-po--swatch cl-po--swatch-button ${classMap(sizeClassMap(option, 'small'))}" style=${styleMap(buttonStyleMap(option,buttonColorStyleMap(option)))}
                             @click=${(e) => config.productForm.dispatchEvent(new CustomEvent('option:export', { detail: option, cancelable: true, bubbles: true })) }>
                             ${option.params.btnText || 'Download'}
                        </div>
                 </label>
            </div>
        `
};